module.exports = {"659003001":"齐干却勒街道","659003002":"前海街道","659003003":"永安坝街道","659003501":"兵团四十一团","659003504":"兵团四十四团","659003509":"兵团四十九团","659003510":"兵团五十团","659003511":"兵团五十一团","659003513":"兵团五十三团","659003514":"兵团图木舒克市喀拉拜勒镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659003.json
// module id = 3152
// module chunks = 0